// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610050451/js/" + chunkId + "." + {"44":"eccd8259","225":"22018fb0","481":"c78b6e1d","486":"0a2dcfc9","770":"f356eff2"}[chunkId] + ".0.8921281473710533.chunk.js";
};